import { render, staticRenderFns } from "./PreAccInvoiceItems.vue?vue&type=template&id=2f03597e&scoped=true&"
import script from "./PreAccInvoiceItems.vue?vue&type=script&lang=ts&"
export * from "./PreAccInvoiceItems.vue?vue&type=script&lang=ts&"
import style0 from "./PreAccInvoiceItems.vue?vue&type=style&index=0&id=2f03597e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f03597e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
